import React, {Component} from 'react';
import Apikeys from '../utils/api-keys'
import Radium from 'radium'
import Colors from '../utils/colors'
import Breakpoints from '../utils/breakpoints'
import WhiteButton from '../components/WhiteButton'
import marked from 'marked';
import contentfulData from '../../contentfuldata/data.json';
import {Bluebutton} from "./Bluebutton";
import {getLang} from '../utils/util-functions'
export class MapClinicComponent extends Component {

  constructor(props, context) {
    super(props, context);
  }

  initMap(){
    const coords = this.props.clinic.coordinates
    if (typeof google === 'undefined')
      return;
    let map = new google.maps.Map(document.getElementById('map'), {
      zoom: 14,
      center: {lat: coords.lat, lng: coords.lon}
    });
    let pos = new google.maps.LatLng(coords.lat, coords.lon);
    let marker = new google.maps.Marker({
      position: pos,
      map: map
    });
  }


  componentDidMount() {
    const script = document.createElement("script");
    let self = this;
    script.src = "https://maps.googleapis.com/maps/api/js?key="+Apikeys.googleApiKey;

    script.id = "mapscriptid";

    if (document.getElementById(script.id)){
      self.initMap();
      return;
    }
    document.body.appendChild(script);

    if(script.readyState) {  //IE
      script.onreadystatechange = function() {
        if ( script.readyState === "loaded" || script.readyState === "complete" ) {
          script.onreadystatechange = null;
          self.initMap();
        }
      };
    } else {  //Others

      script.onload = function() {
        self.initMap();
      };
    }

  }

  getEncodedAddress(address){
    let encoded = address;
    try{
      encoded = encodeURIComponent(address);
    } catch(e){
      encoded = "";
    }
    return encoded;
  }

  changeClinic(url){
    if (url.startsWith('http')) {
      window.location = url
    } else {
      this.props.history.push(url);
    }
  }

  render() {
    const brand = getLang();
    const clinic = this.props.clinic;
    const address = clinic.address || "";
    const openingTimes = clinic.openingTimes || "";
    const bookingButtonText = contentfulData.singleData[brand].singleData.clinicBookingText;
    const closeByText = contentfulData.singleData[brand].singleData.closeByText;
    const directionsText = contentfulData.singleData[brand].singleData.drivingDirectionsText;
    const directionsLink = "https://www.google.se/maps/dir/?api=1&destination=";
    const phoneText = contentfulData.singleData[brand].singleData.phoneText;
    marked.setOptions({
      breaks: true
    });

    return (
        <div style={styles.main}>
          <div style={styles.itemArea} className="clearfix">
              <div style={styles.itemArea.single} className="col-xs-12 col-md-6">
                <h3>Vettris {clinic.name}</h3>
                <div className="row">
                  <div className="col-xs-6">
                    <p dangerouslySetInnerHTML={ {__html: marked(address)} }></p>
                    <br/>
                    <p><span style={{fontWeight: 'bold'}}>{phoneText}</span> {clinic.phone}</p>
                    <div>
                      <p><span style={{fontWeight: 'bold'}}>{closeByText}</span> {clinic.inTheNeighborhood}</p>
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <p dangerouslySetInnerHTML={ {__html: marked(openingTimes)} }></p>
                  </div>
                  <div className="col-xs-10 col-xs-offset-1">
                    <div className="col-xs-12" style={styles.buttonStyles}> <WhiteButton clickFunc={() => this.changeClinic(this.props.clinic.bookingUrl)} text={bookingButtonText + " " + this.props.clinic.name}/> </div>
                  </div>
                </div>
              </div>
              <div style={styles.itemArea.singleMobile}>
                <div className="row">
                  <div className="col-xs-12" style={styles.buttonStyles}> <Bluebutton clickFunc={() => this.changeClinic(this.props.clinic.bookingUrl)} text={bookingButtonText + " " + this.props.clinic.name}/> </div>
                  <div className="col-xs-12" style={styles.buttonStyles}> <a style={styles.bluebuttonStyle} href={"tel:"+clinic.phone}>{clinic.phone}</a> </div>
                  <div className="col-xs-12" style={styles.responsiveDivider}> <p dangerouslySetInnerHTML={ {__html: marked(address)} }></p></div>
                  <div className="col-xs-12"><p dangerouslySetInnerHTML={ {__html: marked(openingTimes)} }></p></div>
                  <div className="col-xs-12" style={styles.buttonStyles}> <a style={styles.bluebuttonStyle} href={directionsLink+this.getEncodedAddress(address)}><i className="glyphicon glyphicon-road" style={styles.bluebuttonStyle.icon}></i>{directionsText}</a> </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6" style={styles.mapContainer}>
                <div style={styles.map} id="map">

                </div>
              </div>
          </div>
        </div>
    );
  }

}

const styles = {
  main: {

  },
  itemArea: {
    color: '#ffffff',
    backgroundColor: Colors.darkBlue,
    borderRadius: Breakpoints.borderRadius,
    [Breakpoints.media.siteUnderPadWidth]: {
      backgroundColor: "#ffffff",
    },
    single: {
      padding: 20,
      fontWeight: 300,
      [Breakpoints.media.siteUnderPadWidth]: {
        display: 'none'
      }
    },
    singleMobile: {
      [Breakpoints.media.siteOverPadWidth]: {
        display: 'none'
      },
      color: Colors.darkBlue

    }
  },
  buttonStyles: {
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 20,
    color: Colors.darkBlue,
    fontWeight: 400,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: 10,
      marginBottom: 10
    }
  },
  mapContainer: {
    paddingRight: 0,
    paddingLeft: 0,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  },
  map: {
    width: '100%',
    minHeight: '400px',
    height: '100%',
    borderBottomRightRadius: Breakpoints.borderRadius,
    borderTopRightRadius: Breakpoints.borderRadius,
    zIndex: 0
  },
  paragraph: {
    width: '50%'
  },
  bluebuttonStyle: {
    padding: 10,
    backgroundColor: Colors.mainBlue,
    color: "#ffffff",
    textAlign: 'center',
    borderRadius: 25,
    fontSize: 18,
    display: 'block',
    fontWeight: 'lighter',
    opacity: '0.8',
    textTransform: 'uppercase',
    width: '100%',
    icon: {
      color: '#ffffff',
      fontSize: 20,
      position: 'relative',
      top: 5,
      marginRight: 10
    }
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  }
};

export default Radium(MapClinicComponent);



// WEBPACK FOOTER //
// ./src/components/MapClinicComponent.js